import type { Nullable, Nullish } from '@payaca/utilities/types';

export interface User {
  deactivatedAt: string | null;
  email: string;
  enableAllNotifications: any;
  firstname: string;
  id: number;
  publicId: string;
  inviteToken?: string;
  verifyToken?: string | null;
  isPayacaAdmin: boolean;
  isDemo: boolean;
  lastname: string;
  name: string;
  notificationSettings: any;
  oneTimeLoginToken?: string;
  verifiedAt: string | null;
  userColour?: string;
  systemRole?: string;
  gasSafeIdCardNumber?: number;
  userSignature?: string;
  pendingEmail: string | null;
  costPerHour?: Nullable<number>;
  termsAndPrivacyVersion?: number;
  referralToken?: string;
  isPrimaryAccountUser: boolean;
  contactNumber?: string;
  sortOrder?: Nullish<number>;
  emailSignature?: Nullish<string>;
  avatarUrl?: string;
}

export type UserRow = {
  id: number;
  // TODO
};

/** Wire code distinguishing an expired invitation from an unrecognised one. */
export const INVITE_EXPIRED_ERROR = 'INVITE_EXPIRED';

export enum UserStatus {
  INVITED = 'Invited',
  INVITE_EXPIRED = 'Invite expired',
  ACTIVE = 'Active',
  DEACTIVATED = 'Deactivated',
  NOT_VERIFIED = 'Not verified',
}
